module.exports = __webpack_public_path__ + "static/img/brightness.c8fbdec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/brightness.png
// module id = 44
// module chunks = 1 2